import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  VStack,
  Text,
  useColorModeValue,
  Spinner,
  Center,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import useAxios from "axios-hooks";
import { useSetRecoilState } from "recoil";
import { toastState } from "atoms/toastState";
import logger from "infra/logger";
import PayrunsTable from "./PayrunsTable";

// Motion components
const MotionBox = motion(Box);

const PayoutsList = () => {
  const setToast = useSetRecoilState(toastState);
  const [payoutsData, setPayoutsData] = useState([]);

  // Theme colors
  const textColor = useColorModeValue("gray.700", "white");
  const bgColor = useColorModeValue("gray.50", "gray.900");

  const [{ loading }, execute, cancelRequest] = useAxios(
    {
      url: `/api/payouts/all`,
      method: "GET",
    },
    { manual: true },
  );

  const fetchPayoutsData = useCallback(async () => {
    try {
      const response = await execute();
      const responseData = response.data.data || [];
      setPayoutsData(responseData);
      logger.log("Payouts data fetched:", responseData);
    } catch (error) {
      logger.error("Error fetching payouts data:", error);
      if (error?.code !== "ERR_CANCELED") {
        setToast({
          isOpen: true,
          title: "Error Occurred",
          status: "error",
          description:
            error?.response?.data?.error || "Failed to fetch payouts data",
        });
      }
    }
  }, [execute, setToast]);

  useEffect(() => {
    fetchPayoutsData();
    return () => cancelRequest();
  }, [fetchPayoutsData, cancelRequest]);

  if (loading) {
    return (
      <Center h="400px">
        <VStack spacing={4}>
          <Spinner size="xl" color="brand.500" thickness="4px" />
          <Text color={textColor}>Loading payouts data...</Text>
        </VStack>
      </Center>
    );
  }

  return (
    <Box px={{ base: 4, md: 6 }} bg={bgColor} minH="100vh">
      <MotionBox
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        w="100%"
      >
        <VStack spacing={6} align="stretch">
          {/* Payruns Table */}
          <PayrunsTable payoutsData={payoutsData} />
        </VStack>
      </MotionBox>
    </Box>
  );
};

export default PayoutsList;
